import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { clearState } from '../../app/store/clear-state.reducer';
import { DriverEffects } from './driver.effects';
import { driverReducer, initialState } from './driver.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('driver', driverReducer, { initialState: initialState, metaReducers: [clearState] }),
    EffectsModule.forFeature([DriverEffects])
  ],
  providers: [DriverEffects]
})
export class DriverStoreModule {}
